<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-image-polaroid', fontSet: 'fad'}"
	[headerText]="headerText"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent [ngSwitch]="data.type">
		<ng-container *ngIf="data | typeGuard: TypePredicates.isMediaDialogInput as mediaInput">
			<div [style.backgroundImage]="'url(' + simUtilityService.getMediaPath(mediaInput.media) + ')'" class="img">
				<div *ngIf="imageLoadError" class="errorLoading">
					<i class="fad fa-file-image fa-3x"></i>
					<div class="text">
						{{ T.IMAGE_DIALOG_TEXT | translate }}
					</div>
				</div>
			</div>

			<img (error)="errorImg()" [src]="simUtilityService.getMediaPath(mediaInput?.media)" hidden />
		</ng-container>

		<ng-container *ngIf="data | typeGuard: TypePredicates.isUrlDialogInput as urlInput">
			<div [style.backgroundImage]="'url(' + urlInput.mediaUrl + ')'" class="img">
				<div *ngIf="imageLoadError" class="errorLoading">
					<i class="fad fa-file-image fa-3x"></i>
					<div class="text">
						{{ T.IMAGE_DIALOG_TEXT | translate }}
					</div>
				</div>
			</div>

			<img (error)="errorImg()" [src]="urlInput.mediaUrl" hidden />
		</ng-container>
	</ng-container>
</sim-basic-material-dialog>
